export default function isEmployedSelector(state) {
  return (
    state.primaryIncomeSource === 'employment' ||
    state.primaryIncomeSource === 'self_employed'
  );
}
